<template>
    <div v-if="Object.keys(validationErrors).length > 0" :style="Object.keys(validationErrors).length > 0 ? {'display': 'block'} : {'display' : 'none'} " class="invalid-feedback">
        <div v-for="(err,key) in validationErrors" :key="key">
            {{err.$message}}
        </div>
    </div>
</template>

<script setup>
import { toRefs } from 'vue'

const props = defineProps({
    validationErrors: { type: Object, required: false, default: () => [{}]}
});

toRefs(props);

</script>